export default __webpack_public_path__ + "static/media/weldinggg.c20e1b01.png";